import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LogService, ServiceRouter } from '@pershing/pershing-core';
import { NXIRestServiceDefinition } from './NXI-Rest-service-definition';
import { Observable } from 'rxjs';

@Injectable()
export class NxiRestService  {
    public serviceUrl: string;
    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter) {
        logService.info('NxiRestService : constructor Initializing');
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(NXIRestServiceDefinition.getInstance());
       // this.serviceUrl = 'http://dev-advisor-netxinvestor.bnymellon.net:8080/services/netxclient.rest-service';
        logService.info('NxiRestService : URL', this.serviceUrl);
    }
    public getNxiPortfolioRestUrlResponse (nxiRestUrl: string): Observable<any> {
        return this.http.get(this.serviceUrl + '/portfolio/' + nxiRestUrl );
    }

    public getBrandedURL(): Observable<any> {
        const timeNow = Date.now();
        return this.http.get(this.serviceUrl + '/portfolio/brandedUrl?time=' + timeNow, { responseType: 'json' });
    }

}
